//import { signalRInstance } from "../api/signalrService";
import myApp from "../main";
export default {
  methods: {
    logErrorsAndExceptions(location, error) {
      if (
        myApp.$appInsights &&
        myApp.$appInsights.trackException &&
        process.env.VUE_APP_INSIGHTS_KEY
      ) {
        myApp.$appInsights.trackException({
          exception: new Error(location),
          properties: error,
        });
      } else {
        console.error(location, ":", error);
      }
    },
    logInfoAndDebug(location, message) {
      if (
        myApp.$appInsights &&
        myApp.$appInsights.trackEvent &&
        process.env.VUE_APP_INSIGHTS_KEY
      ) {
        myApp.$appInsights.trackEvent({
          name: location,
          properties: message,
        });
      } else {
        console.log(location, ":", message);
      }
    },
  },
};
